<template>
  <div>
    <decision-form />

    <decision-list-form class="mt-5" />

    <panel>
      <w-button class="btn-secondary" text="Wróć" @click="goBack" />
    </panel>
  </div>
</template>

<script>
import DecisionForm from '@/components/forms/decision/DecisionForm';
import DecisionListForm from '@/components/forms/decision/DecisionListForm';
import Panel from '@/components/panel/Panel';

// @vuese
// Widok decyzji
// @group Document
export default {
  components: { DecisionForm, DecisionListForm, Panel },

  methods: {
    // @vuese
    // Wraca do szczegółów dokumentu
    goBack() {
      this.$router.push({ name: 'documentDetails' });
    }
  }
};
</script>
